import React, { useEffect } from 'react';
import { authAtom } from '_state';
import { useRecoilState } from 'recoil';
import { socketWrapper } from '../../../_helpers/socket-wrapper';
import useSocketAction from '_actions/socket.action';
import { socketConnected } from '_state/socket';

export default function Socket(props) {
    let [auth, setAuth] = useRecoilState(authAtom);
    let socketAction = useSocketAction();
    let [isSocketConnected, setSocketConnected] = useRecoilState(socketConnected);

    useEffect(() => {
        if (!socketWrapper.initiated) {
            socketWrapper.initConnection(auth);
        }
        socketWrapper.socket.removeAllListeners();
        socketWrapper.socket.on("connect", socketAction.onConnected);

        let id = setInterval(() => {
            if (socketWrapper.isConnected) {
                setSocketConnected(true);
                clearInterval(id);
            }
        }, 300);
    }, []);

    return <></>;
}
